import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  invoiceBrandingService,
  UpsertInvoiceBrandingPayload,
} from '../services/invoiceBrandingService';
import { queryKeys } from '../lib/queryClient';

export const useInvoiceBranding = () =>
  useQuery({
    queryKey: queryKeys.invoiceBranding.current(),
    queryFn: () => invoiceBrandingService.getBranding(),
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });

export const useSaveInvoiceBranding = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: UpsertInvoiceBrandingPayload) =>
      invoiceBrandingService.saveBranding(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.invoiceBranding.current(),
      });
    },
  });
};
